import { FeedModuleTypeEnum, IGif } from "@/common/services/types";
import { GifPreview } from "@/components/gifPreview/GifPreview";
import { FeedModuleContainer } from "../FeedModules/FeedModuleContainer";
import "./BoostedGifModule.scss";

interface IProps {
  boostedGifs?: IGif[];
  counter: number;
  position: number;
  moduleId: string;
  moduleType: FeedModuleTypeEnum;
}

export const BoostedGifModule = ({ boostedGifs, counter, position, moduleId, moduleType }: IProps) => {
  if (!boostedGifs) {
    return null;
  }

  if (!boostedGifs[counter - 1]) {
    return null;
  }

  return (
    <FeedModuleContainer
      moduleId={moduleId}
      moduleType={moduleType}
    >
      <GifPreview
        gif={boostedGifs[counter - 1]}
        position={position + 1}
        hideGif={() => {}}
      />
    </FeedModuleContainer>
  );
};
